import { render, staticRenderFns } from "./ProductMapping.vue?vue&type=template&id=f59e1138&scoped=true&"
import script from "./ProductMapping.vue?vue&type=script&lang=js&"
export * from "./ProductMapping.vue?vue&type=script&lang=js&"
import style0 from "./ProductMapping.vue?vue&type=style&index=0&id=f59e1138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59e1138",
  null
  
)

export default component.exports